// import { theme } from 'antd';
import type { ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#0A287D',
    colorText: '#333333',
  },
  components: {
    Button: {
      primaryShadow: 'none',
    },
    Table: {
      rowSelectedBg: 'rgba(170, 178, 189, 0.38)',
      rowHoverBg: 'rgba(170, 178, 189, 0.2)',
      rowSelectedHoverBg: 'rgba(170, 178, 189, 0.2)',
    },
    Menu: {
      itemHoverBg: 'rgba(170, 178, 189, 0.2)',
      itemSelectedBg: 'rgba(170, 178, 189, 0.38)',
    },
  },
};

/** 组件库样式前缀 */
export const PREFIX_CLS = 'rexel';
